import * as React from 'react';
import { styled, SxProps } from '@mui/material/styles';

const StyWidgetTitle = styled('div', {
    name: 'StyWidgetTitle',
})({
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: '2',
});

const WidgetTitle = ({
    children,
    sx = undefined,
}: {
    children: React.ReactNode;
    sx?: SxProps;
}): React.ReactElement => <StyWidgetTitle sx={sx}>{children}</StyWidgetTitle>;

export default WidgetTitle;
